<svg [attr.height]="height" [attr.width]="width" class="svg">
  <path [attr.d]="path" class="path" />
  <g class="points">
    <circle [attr.cx]="start.x" [attr.cy]="start.y" r="4" />
    <circle [attr.cx]="end.x" [attr.cy]="end.y" r="4" />
  </g>
</svg>
